import React from "react";
import { Field, ErrorMessage } from "formik";

export default function Fields({
  type,
  name,
  className,
  placeholder,
  id,
  ariaDescribedby,
  onChange,
  onBlur,
  value,
  defaultValue,
  touched,
  errors,
  checked,
  disabled = false,
}) {
  return (
    <>
      <Field
        type={type}
        name={name}
        className={className}
        id={id}
        aria-describedby={ariaDescribedby}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        checked={checked}
        disabled={disabled}
        defaultValue={defaultValue}
      />
      {type !== "file" && (
        <div className="mt-0 mx-0">
          <ErrorMessage
            name={name}
            component={({ children }) => (
              <div className="text-start text-danger mb-2 mt-2">{children}</div>
            )}
          />
        </div>
      )}
    </>
  );
}
